import React from "react";

const HomeNumbers = () => {
  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 uppercase rounded-full">
            数据统计
          </span>
          <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
            来自于新一代人工智能技术的强大产品性能
          </h2>
          <p className="mb-24 text-base md:text-lg text-slate-500">
          我们的产品可以被嵌入到自动化设备、机器人设备、广义机器人设
          备等多个领域，实现生产力的提升。
          </p>
        </div>
        <div className="sm:grid sm:grid-cols-2 lg:grid-cols-4 -mx-4 text-center text-slate-800">
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">10.000+</p>
            <h3 className="text-slate-500">新增应用领域</h3>
          </div>
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">500.000+</p>
            <h3 className="text-slate-500">嵌入设备数</h3>
          </div>
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">100.000+</p>
            <h3 className="text-slate-500">企业用户数</h3>
          </div>
          <div className=" px-4 mb-8 md:mb-0">
            <p className="py-4 text-3xl font-bold text-blue-600">5.000+</p>
            <h3 className="text-slate-500">活终端用户数</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeNumbers;
